<template>
  <div class="bbox">
    <vannav></vannav>
    <dropdown
      ref="ondefvalue"
      :areaList="areaList"
      :defvalue="defvalue"
      @code="code"
    ></dropdown>
    <pick @updateList="updateList"></pick>
    <div v-if="topList" class="text_ban">
      <div>
        <span>
          <img :src="require('../assets/energy/energy.png')" alt="" />
          <i>总能耗 (kwh)</i>
        </span>
        <span>{{ topList.energy }}</span>
      </div>
      <div>
        <span>
          <img :src="require('../assets/energy/c.png')" alt="" />
          <i> 总排放 (kgCO₂)</i></span
        >
        <span>{{ topList.energyCO2 }}</span>
      </div>
    </div>
    <div v-for="(item, index) in enargyList" :key="index" class="text_bbb">
      <div class="b1">
        <span>{{ item.date }}</span>
        <span>{{ item.ratio }}</span>
      </div>
      <div class="b2">
        <div>
          <span> 能耗(kwh)：</span>
          <span> 碳排放(kgCO₂)：</span>
        </div>
        <div>
          <span> {{ item.energy }} </span>
          <span>{{ item.energyCO2 }}</span>
        </div>
      </div>
    </div>
    <empty :empty="empty"></empty>
  </div>
</template>
<script>
import pick from "../common/pick.vue";
import dropdown from "../common/dropdown.vue";
import { mapGetters } from "vuex";
import { areaEnergyById } from "@/api/energy";
import { Notify } from "vant";
import { checkData } from "../util/index";

export default {
  data() {
    return {
      img: require("../assets/empty/empty.png"),
      empty: false,
      areaList: {
        province_list: {},
        city_list: {},
        county_list: {},
      },
      defvalue: [],
      // 查询字段
      dateType: "",
      areaId: "",

      date: "",
      // 合计
      topList: {},
      // 数据渲染
      enargyList: [],
    };
  },
  mounted() {
    this.getcode();
  },
  computed: {
    ...mapGetters({
      TreeCode: "energy/getareatreeCode",
    }),
  },
  methods: {
    getcode() {
      this.areaList.province_list = this.TreeCode.provinceList;
      this.areaList.city_list = this.TreeCode.cityList;
      this.areaList.county_list = this.TreeCode.countryList;
      this.defvalue = [
        {
          code: this.TreeCode.idCode[0].code,
          name: this.areaList.province_list[this.TreeCode.idCode[0].code],
        },
        undefined,
        undefined,
      ];
      this.$refs.ondefvalue.ondefvalue(this.defvalue);
    },
    // 调用接口加载
    infoareaEnergyById() {
      areaEnergyById(this.$token, this.date, this.areaId, this.dateType)
        .then((res) => {
          if (res.data.code == 200) {
            if (!checkData(res.data.data.areaEnergy)) {
              this.topList = {};
              this.enargyList = [];
              this.empty = true;
            } else {
              this.empty = false;
              this.topList = {};
              this.enargyList = [];
              this.topList = res.data.data.areaEnergy.pop();
              this.topList.energy = this.topList.energy.toFixed(2);
              this.topList.energyCO2 = this.topList.energyCO2.toFixed(2);
              this.enargyList = res.data.data.areaEnergy.map((item) => {
                item.energy = item.energy.toFixed(2);
                item.energyCO2 = item.energyCO2.toFixed(2);
                return item;
              });
            }
          } else {
            Notify({ type: "danger", message: res.data.msg });
          }
        })
        .catch(() => {});
    },
    // 选中的值
    code(e) {
      console.log("code");
      let a = null;
      this.TreeCode.idCode.map((item) => {
        if (item.code == e[0].code) {
          a = item.id;
        }
        if (e[1] !== undefined) {
          if (item.code == e[1].code) {
            a = item.id;
          }
        }
      });
      this.areaId = a;
      this.infoareaEnergyById();
    },
    // 选中日月年
    updateList(e) {
      console.log(e);
      this.dateType = e.dateType;
      this.date = e.date;
      if (this.areaId != null) {
        this.infoareaEnergyById();
      }
    },
  },

  components: {
    pick,
    dropdown,
  },
};
</script>

<style lang="less" scoped>
.empty {
  width: 100%;
  background-color: #fff;

  img {
    width: 100%;
  }
}

.text_ban {
  width: 100%;
  height: 2rem;
  background-color: #ffffff;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  & > div {
    height: 100%;
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    & > span {
      line-height: 0.7rem;
      &:first-child {
        display: flex;
        align-items: center;
        justify-content: space-between;
        i {
          font-style: normal;
          margin-left: 5px;
        }
        img {
          width: 13px;
          height: 13px;
        }
      }

      &:first-child {
        font-size: 13px;
        color: #979b9bff;
      }

      &:last-child {
        font-weight: bolder;
        font-size: 20px;
      }
    }
  }
}

.bbox {
  width: 100%;
  height: 100vh;
  background-color: rgba(244, 246, 250, 1);
  overflow: auto;
}

.text_bbb {
  background-color: #ffffff;
  margin-bottom: 10px;
  box-shadow: 0 0 2px 0 #cccccc;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & > div {
    width: 100%;

    &.b1 {
      padding: 0 10px;
      box-sizing: border-box;
      font-weight: bolder;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      background-color: #ffffff;
      box-shadow: 0 0 2px 1px #e8efef;
      margin-bottom: 1px;

      & > span:first-child {
        color: rgba(70, 122, 255, 0.9);
        font-size: 17px;
      }

      & > span:last-child {
        color: rgba(70, 122, 255, 0.5);
        font-size: 13px;
      }
    }

    &.b2 {
      padding: 0 10px;
      box-sizing: border-box;
      height: 60px;
      background-color: rgba(251, 251, 251, 1);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      & > div {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          flex: 1;
          text-align: left;
        }
      }

      & > div:first-child {
        height: 20px;
        font-size: 13px;
        color: rgba(35, 39, 38, 0.6);
      }

      & > div:last-child {
        height: 30px;
        font-size: 19px;
        color: #4a5050cc;
        font-weight: 600;
      }
    }
  }
}
</style>
